module.exports = __webpack_public_path__ + "img/tooth.59f66477.png";